/* Videowise widget — vendor line above the product title in the shoppable-product cards.
   Requires shadow DOM to be OFF on the widget. The widget re-renders on slide change, so this
   runs off a debounced MutationObserver and is idempotent per title anchor. */
(function () {
  'use strict';

  // Videowise varies its class names, so match on the stable substring rather than the full class.
  var TITLE_SELECTOR = 'a[class*="shoppable-product--content--title"]';
  var VENDOR_CLASS = 'vw-vendor';
  var DONE_ATTR = 'data-vw-vendor-done';
  var DEBOUNCE_MS = 150;

  // Turn on with ?vwvendor=debug in the URL, or localStorage.vwVendorDebug = '1'.
  var DEBUG = /[?&]vwvendor=debug/.test(location.search) ||
    (function () { try { return localStorage.getItem('vwVendorDebug') === '1'; } catch (e) { return false; } })();
  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[vw-vendor]'].concat(Array.prototype.slice.call(arguments)));
  }

  // json path -> Promise<product|null>. Negative results are cached too: a 404 will not fix
  // itself, and retrying on every mutation would hammer the store.
  var cache = Object.create(null);
  function getProduct(path) {
    if (!cache[path]) {
      cache[path] = fetch(path, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[path];
  }

  /* Build the .js path from the anchor's own href, which keeps any market/locale prefix
     ("/en-gb/products/x") and any collection prefix ("/collections/y/products/x"). */
  function jsonPathFor(a) {
    var m = (a.getAttribute('href') || '').match(/^(.*?)\/products\/([^/?#]+)/);
    return m ? m[1] + '/products/' + m[2] + '.js' : '';
  }

  function decorate(title) {
    if (title.getAttribute(DONE_ATTR)) return;
    var path = jsonPathFor(title);
    if (!path) { log('href has no /products/ segment:', title.getAttribute('href')); return; }
    title.setAttribute(DONE_ATTR, '1');            // claim it before the async hop
    getProduct(path).then(function (p) {
      if (!p) { log('no product JSON at', path); return; }
      var vendor = String(p.vendor == null ? '' : p.vendor).replace(/\s+/g, ' ').trim();
      log(path, '→ vendor:', vendor || '(EMPTY on this product)');
      if (!vendor || !title.parentNode) return;
      // A re-render can leave a stale line in place — reuse it instead of stacking a second one.
      var prev = title.previousElementSibling;
      if (prev && prev.classList.contains(VENDOR_CLASS)) { prev.textContent = vendor; return; }
      var el = document.createElement('span');
      el.className = VENDOR_CLASS;
      el.textContent = vendor;
      title.parentNode.insertBefore(el, title);
    });
  }

  var timer = null;
  function scan() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var titles = document.querySelectorAll(TITLE_SELECTOR);
      log('title anchors on page:', titles.length);
      Array.prototype.forEach.call(titles, decorate);
    }, DEBOUNCE_MS);
  }

  // The widget mounts async and re-renders on slide change, so watch the document and let the
  // debounce absorb the churn from the video carousel.
  function start() {
    log('loaded');
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
  // Console handle: VW_VENDOR.scan(), VW_VENDOR.cache, VW_VENDOR.selector
  window.VW_VENDOR = { scan: scan, cache: cache, getProduct: getProduct, selector: TITLE_SELECTOR };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
